import { Component, Input } from '@angular/core';

import { Playlist } from './vimeo.model';

@Component({
    selector: 'cmps-vimeo-text-playlist',
    templateUrl: './text-playlist.vimeo.component.html',
})
export class TextPlaylistVimeoComponent {
    @Input() list: Playlist;
}
